import templateUrl from 'emun.invoice/credit-memo-prompt.htm'
import controller from 'emun.invoice/credit-memo-prompt.controller'
import config from 'servicestack/email/send-email-config'
import modals from 'webmodals/modals'

export default (options) => modals.open(Object.assign({
    size: options.size || 'md',
    backdrop: 'static',
    templateUrl: options.templateUrl || templateUrl,
    resolve: {
        options: () => Object.assign(
            {
                commandLabel: 'Save',
                transitionTo: 'retailer.creditmemo',
                title: `Request Credit: ${options.model.invoiceId}`,
            },
            options,
            config)
    },
    bindToController: true,
    controller,
    controllerAs: '$ctrl'
}, options.modal)).result;